import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';

import { CarTrafficEffects } from '@ruby/modules/car-traffic/store/effects/car-traffic.effects';
import * as fromTrafficHistory from '@ruby/modules/car-traffic/store/reducers/car-traffic.reducer';

export const featureKey = 'traffic-history';

export interface State {
  [fromTrafficHistory.featureKey]: fromTrafficHistory.State;
}

export const reducer: ActionReducerMap<State> = {
  [fromTrafficHistory.featureKey]: fromTrafficHistory.reducer
};

export const selectTrafficHistoryFeatureState = createFeatureSelector<State>(featureKey);

export const effects = [
  CarTrafficEffects
];
